// extracted by css-extract-rspack-plugin
export default {"cls1":"TopBar-cls1_y59","cls2":"TopBar-cls2_6qb TopBar-cls1_y59"};